<button (click)="click.next(); $event.stopPropagation()"
    class="bg-none  icon-size-5 p-0 m-0 max-h-5 max-w-5"
    [disabled]="disabled" [class.disabled]="disabled" [matTooltip]="label">
    <mat-icon [class.icon-size-5]="size==='sm'" [style.color]="color" [svgIcon]="icon" *ngIf="icon"> </mat-icon>


</button>
